export class AuthorizationError extends Error {
  status: number;

  constructor(status: number, message = 'Authorization failed') {
    super(message);
    this.name = 'AuthorizationError';
    this.status = status;
  }
}